// Fill
export const MAP_GEOJSON_DEFAULT_FILL_COLOR = "#9DA2CE";
export const MAP_GEOJSON_DEFAULT_FILL_OPACITY = 0.35;

// Stroke
export const MAP_GEOJSON_DEFAULT_STROKE_COLOR = "#5F679E";
export const MAP_GEOJSON_DEFAULT_STROKE_OPACITY = 1;
export const MAP_GEOJSON_DEFAULT_STROKE_WEIGHT = 2;
